import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Tab, Tabs } from 'react-bootstrap';
import {
  orderTableTabs,
  orderStatuses,
  tableTabStatuses,
} from './util/constants';
import './OrderStatus.css';
import MultiStatusTable from './MultistatusTable';
import { LoadMoreOrderTable } from './LoadMoreOrderTable';
import { OrderTableSearch } from './OrderTableSearch';
import { Modal, ModalContent } from '@raptormaps/modal';
import { Row } from '@raptormaps/layout';
import { CircularProgress } from '@raptormaps/progress';

import { OrderActionCreator as OrderActions } from '../../actions/orderActions';
import {
  useFilteredOrders,
  useInvalidateAllOrders,
  useOrders,
} from '../../hooks/useOrders';
import { Button } from '@raptormaps/button';

export const OrderStatus = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const filterType = params.get('type');
  const filterText = params.get('value');
  const dispatch = useDispatch();

  const orgs = useSelector(state => state.session.orgs);

  const { data: allOrders, isLoading: loading } = useOrders(
    tableTabStatuses[orderTableTabs.ONGOING].join(','),
  );
  const { data: filteredOrders, isLoading: filteredLoading } =
    useFilteredOrders(filterText, filterType);
  const { invalidateAllOrders } = useInvalidateAllOrders();

  useEffect(() => {
    dispatch(OrderActions.getAllInstructions());
  }, []);

  return (
    <div className="order-status-container">
      <div className="order-status-header">
        <OrderTableSearch orderActions={OrderActions} />
        <Button onClick={invalidateAllOrders} icon="Rotate">
          Refresh
        </Button>
      </div>
      <Tabs id="ordersTable" defaultActiveKey={'ongoing'}>
        <Tab eventKey="ongoing" title="Ongoing" style={{ paddingTop: '20px' }}>
          <MultiStatusTable
            ordersByStatus={
              filteredOrders !== undefined ? filteredOrders : allOrders
            }
            orgs={orgs}
            isLoading={loading}
          />
        </Tab>
        <Tab eventKey="completed" title="Delivered">
          <LoadMoreOrderTable
            status={orderStatuses.DELIVERED}
            orgs={orgs}
            activeTab={orderTableTabs.COMPLETED}
            filteredOrders={filteredOrders?.filter(
              order => order.status === orderStatuses.DELIVERED,
            )}
          />
        </Tab>
        <Tab eventKey="pending" title="Pending">
          <LoadMoreOrderTable
            status={orderStatuses.STARTED}
            orgs={orgs}
            activeTab={orderTableTabs.PENDING}
            filteredOrders={filteredOrders?.filter(
              order => order.status === orderStatuses.STARTED,
            )}
          />
        </Tab>
        <Tab eventKey="cancelled" title="Cancelled">
          <LoadMoreOrderTable
            status={orderStatuses.CANCELLED}
            orgs={orgs}
            activeTab={orderTableTabs.CANCELLED}
            filteredOrders={filteredOrders?.filter(
              order => order.status === orderStatuses.CANCELLED,
            )}
          />
        </Tab>
      </Tabs>

      <Modal open={loading || filteredLoading}>
        <ModalContent>
          <Row justify="center" align="center" style={{ padding: 24 }}>
            <CircularProgress size={75} />
          </Row>
        </ModalContent>
      </Modal>
    </div>
  );
};
